/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetAssetUploadPartUrlResponseContent
 */
export interface GetAssetUploadPartUrlResponseContent {
    /**
     * URL that the client can use to upload bytes directly to S3.
     * @type {string}
     * @memberof GetAssetUploadPartUrlResponseContent
     */
    uploadUrl: string;
    /**
     * 
     * @type {number}
     * @memberof GetAssetUploadPartUrlResponseContent
     */
    expiresAt: number;
}


/**
 * Check if a given object implements the GetAssetUploadPartUrlResponseContent interface.
 */
export function instanceOfGetAssetUploadPartUrlResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadUrl" in value;
    isInstance = isInstance && "expiresAt" in value;
    return isInstance;
}

export function GetAssetUploadPartUrlResponseContentFromJSON(json: any): GetAssetUploadPartUrlResponseContent {
    return GetAssetUploadPartUrlResponseContentFromJSONTyped(json, false);
}

export function GetAssetUploadPartUrlResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetUploadPartUrlResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'uploadUrl': json['uploadUrl'],
        'expiresAt': json['expiresAt'],
    };
}

export function GetAssetUploadPartUrlResponseContentToJSON(value?: GetAssetUploadPartUrlResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'uploadUrl': value.uploadUrl,
        'expiresAt': value.expiresAt,
    };
}

